<button class="btn-link btn-language" type="button" (click)="showLanguagesDialog()">
  <span class="material-symbols-outlined icon h3"> translate </span>
</button>
